import { ApiResponse } from "../interfaces/apiResponse.interface";
import { VehicleInfo } from "../interfaces/responder.interface";
import { APIMAPIGetRequest, APIMAPIPostRequest } from "./APIMRequest";

export class ResponderService {
    async GetVehicleByLicensePlateOrUniqueId(inputType: string, input: string): Promise<ApiResponse<Array<VehicleInfo>>> {
        try {
            let apimGetRequest = new APIMAPIGetRequest(`api/v1/vehicle?inputType=${inputType}&input=${input}`);
            let res = (await apimGetRequest.send()).result;

            return {
                result: res, statusMessage: "", messageCode: 200, statusCode: ""
            };
        } catch (error: any) {
            const message = error?.response?.data?.statusMessage || error?.message || "Failed to search vehicle";
            const err = new Error(message);
            (err as any).statusCode = error?.response?.status || 500;
            (err as any).statusMessage = message;
            (err as any).messageCode = error?.response?.data?.messageCode || 500;
            throw err;
        }
    }


    // Incident submission - specific method based on info.tsx usage
    async submitIncident(incidentData: {
        incidentId: null;
        vehicleId: number;
        latitude: string;
        longitude: string;
        statusCode: string;
        comment: string;
        incidentDate: string;
    }): Promise<ApiResponse<null>> {
        try {
            let apimPostRequest = new APIMAPIPostRequest(`api/v1/incidents`, JSON.stringify(incidentData));
            let res = (await apimPostRequest.send()).result;
            return {
                result: res, statusMessage: "", messageCode: 200, statusCode: ""
            };
        } catch (error: any) {
            const message = error?.response?.data?.statusMessage || error?.message || "Failed to submit incident";
            const err = new Error(message);
            (err as any).statusCode = error?.response?.status || 500;
            (err as any).statusMessage = message;
            (err as any).messageCode = error?.response?.data?.messageCode || 500;
            throw err;
        }
    }

}